module.exports = __webpack_public_path__ + "static/media/logoc.6d7d7e2f.png";